function ServicesSection({ title, subtitle, items }) {
  return (
    <section className="py-10 sm:py-[60px] bg-dark-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="font-montserrat text-xs tracking-[0.3em] uppercase text-gold mb-4">{subtitle}</p>
          <h2 className="font-playfair text-4xl sm:text-5xl font-bold gold-gradient-text">{title}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-dark-card gold-border gold-border-hover p-8 transition-all duration-500 hover:glow-gold group"
            >
              <div className="flex justify-between items-start mb-6">
                <h3 className="font-playfair text-2xl text-white group-hover:text-gold transition-colors">{item.title}</h3>
              </div>
              <div className="flex items-center space-x-4 mb-6">
                <span className="font-montserrat text-xs tracking-widest text-gold/70 uppercase">{item.duration}</span>
                <span className="w-px h-4 bg-gold/30" />
                <span className="font-montserrat text-sm font-semibold text-gold">{item.price}</span>
              </div>
              <p className="font-montserrat text-lg text-white/60 leading-relaxed">{item.description}</p>
              <div className="section-divider mt-8" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
